import { ETHO } from '../types';
export default {
  type: ETHO,
  service: 'ether1.org',
  url: 'https://rpc.ether1.org',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
